
<!--
@author:panshuwei
@date:2018-08-25
@description:图表的基础库
-->

<template>
    <div :style="chartStyle"></div>
</template>

<script>
import chartMap from '@/model/chartMap';
import chartThemes from '@/model/chartTheme';
import eBase from '@/base/eBase';
import parser from '@/model/chartParser';
import { debounce } from '@/utils';
import _ from 'underscore';

export default {
  props: {
    type: { required: true },
    data: { required: true },
    h: { required: false },
    max_height: { required: false },
    min_height: { required: false },
    scale: { required: false, default: '500%' },
    theme: { required: false, default: 'bar' },
    theme_obj: { required: false, default: undefined },
  },

  data() {
    return {
      chart: null,
      option: {},
      chartStyle: { width: '800px', height: '300px' },
    };
  },

  beforeMount() {
    eBase.debug('[BaseChart.vue][beforeMount][enter]');
    this.registerTheme();
    this.registerMap();
    this.resetSize();
  },

  mounted() {
    eBase.debug('[BaseChart.vue][mounted][enter]');
    this.init();
  },

  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    window.removeEventListener('resize', this.__resizeHanlder);
    this.chart.dispose();
    this.chart = null;
  },

  watch: {
    data: {
      handler() {
        this.init();
      },
      immediated: false,
    },
  },

  computed: {

  },

  methods: {

    init() {
      this.option = parser[this.type](this.data, this.theme_obj);
      this.renderChart(this.option);
      this.addListeners();
    },

    addListeners() {
      this.__resizeHanlder = debounce(() => {
        if (this.chart) {
          this.chart.resize();
        }
      }, 100);
      window.addEventListener('resize', this.__resizeHanlder);
      this.$eventBus && this.$eventBus.$on('resize_all', () => { setTimeout(() => { this.__resizeHanlder(); }, 100); });
    },

    registerTheme() {
      _.each(_.keys(chartThemes), (key) => {
        this.$echarts.registerTheme(key + '', chartThemes[key]);
      });
    },

    registerMap() {
      _.each(_.keys(chartMap), (key) => {
        this.$echarts.registerMap(key + '', chartMap[key]);
      });
    },

    renderChart(opt) {
      if (this.theme) {
        this.chart = this.$echarts.init(this.$el, this.theme);
      } else {
        this.chart = this.$echarts.init(this.$el);
      }

      this.chart.clear();
      this.chart.showLoading();
      this.chart.setOption(opt);
      this.chart.hideLoading();

      this.$emit('renderCompalte', opt.iTitle);
      this.$emit('getChartWrap',this.chart);
    },

    resetSize() {
      let truely_height = this.scale;

      if (this.min_height) {
        truely_height = truely_height < parseFloat(this.min_height) ? parseFloat(this.min_height) : truely_height;
      }

      if (this.max_height) {
        truely_height = truely_height > parseFloat(this.max_height) ? parseFloat(this.max_height) : truely_height;
      }

      if (this.h) {
        truely_height = this.h;
      }

      this.chartStyle = {
        width: '100%',
        height: truely_height,
      };

      this.$emit('resize');
    },

    getChartCount() {
      const arr = parser.compatibleMultChartData(this.data);
      const len = arr.length;

      return len > 0 ? len : 1;
    },

  }, // EOF methods
};
</script>



// WEBPACK FOOTER //
// src/components/common/BaseChart.vue